/**
 * Right-hand category rail configuration for the `/map` page. (Replaces the
 * config that previously lived in the deleted mock fixtures.)
 */

/** The selectable items in the right-hand category rail. */
export type MapCategory =
  | "kpis"
  | "alerts"
  | "events"
  | "gps"
  | "video"
  | "video-mockup"
  | "images"
  | "settings";

/** Whether a category aggregates a whole location or follows the selected machine. */
export type CategoryScope = "location" | "machine" | "map";

export const CATEGORY_SCOPE: Record<MapCategory, CategoryScope> = {
  kpis: "location",
  alerts: "location",
  events: "location",
  gps: "machine",
  video: "machine",
  // Detection-replay demo — self-contained local data, available regardless of selection.
  "video-mockup": "map",
  images: "machine",
  settings: "map",
};

export const CATEGORY_LABEL: Record<MapCategory, string> = {
  kpis: "KPIs",
  alerts: "Alerts",
  events: "Events",
  gps: "GPS",
  video: "Video",
  "video-mockup": "Video (mockup)",
  images: "Images",
  settings: "Settings",
};

/**
 * Order of the right-hand rail. `settings` is rendered pinned at the bottom.
 * KPIs, GPS, Video (mockup) and Images are intentionally hidden from the map —
 * the rail shows only Alerts, Events and the (real) Video. Their config/panels
 * are kept above so they can be re-enabled by adding them back here.
 */
export const CATEGORY_ORDER: MapCategory[] = [
  "alerts",
  "events",
  "video",
];
